import { post, get, request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";

// 获取签名
export function getSign(data) {
  return get("/v1/live/getSignature", data);
}
// 获取房间信息
export function getRoomInfo(data) {
  return get("/v1/live/getRoom", data);
}
// 停止上课
export function stopLive(data) {
  return post("/v1/live/endLive", data);
}
// 开始上课
export function startLive(data) {
  return post("/v1/live/startLive", data);
}
// 获取花名册
export function getRoster(data) {
  return get("/v1/live/getUserList", data);
}
// 获取用户 状态
export function getUserStatus(data) {
  return get("/v1/live/getUserStatus", data);
}
// 移除学员
export function removeUser(data) {
  return post("/v1/live/removeUser", data);
}
// 教师端房间配置
export function setTeacherRoomConf(params) {
  return request(`/v1/live/setTeacherRoomConf`, "POST", {
    json: params,
  });
}
// 获取教师端房间配置
export function getTeacherRoomConf(params) {
  return get("/v1/live/getTeacherRoomConf", params);
}
// 设置用户权限
export function setUserRole(data) {
  return post("/v1/live/setUserPermission", data);
}

//创建文档转码任务
export const createTranscode = (params) =>
  request(`/v1/live/createTranscode`, "POST", {
    json: params,
  });

//查询文档转码任务
export const getDescribeTranscode = (params) =>
  get("/v1/live/describeTranscode", params);
// 修改房间禁言，禁止视频，音频状态
export function updateRoomStatus(data) {
  return post("/v1/live/updateRoomState", data);
}
// 查询转码任务进度
export const getDesTranscode = (params) =>
  get("/v1/live/describeDocument", params);

//举手
export const handUp = (params) =>
  request(`/v1/live/handUp`, "POST", {
    json: params,
  });

// 修改自己的麦克风状态
export const updateState = (params) =>
  request(`/v1/live/updateState`, "POST", {
    json: params,
  });

// 重新录制
export const reRecord = (params) => {
  return request("/v1/live/restartRecord", "POST", {
    json: params,
  });
};

// 修改昵称
export const updateNickname = (params) => {
  return request("/v1/live/updateNickname", "POST", {
    json: params,
  });
};
// 获取房间进行中的工具箱
export function getToolbox(data) {
  return get("/v1/live/getTools", data);
}
// 创建定时器和计时器并且开始计时
export function createTimer(data) {
  return post("/v1/live/timer/create", data);
}
// 重新开始计时
// export function restartTimer(data) {
//   return post("/v1/live/timer/restart", data);
// }
// 继续计时
export function startTimer(data) {
  return post("/v1/live/timer/start", data);
}
// 结束计时器
export function endTimer(data) {
  return post("/v1/live/timer/end", data);
}
// 暂停计时器
export function pauseTimer(data) {
  return post("/v1/live/timer/stop", data);
}

// ========== 答题器相关API ==========
// 创建答题器
export function createAnswer(data) {
  return post("/v1/live/question/create", data);
}
// 结束答题器
export function endAnswer(data) {
  return post("/v1/live/question/end", data);
}
// 设置正确答案
export function setCorrectAnswer(data) {
  return post("/v1/live/question/setAnswer", data);
}
// 获取答题统计
export function getAnswerStats(data) {
  return get("/v1/live/question/statistics", data);
}
// 学生提交答案
export function submitAnswer(data) {
  return post("/v1/live/question/submitAnswer", data);
}
export function liveKeepAlive(data) {
  return post("/v1/userCourse/liveKeepALive", data);
}

// 获取房间售卖信息
export function getRoomCart(data) {
  return get("/v1/roomCart/get", data);
}

// 发布售卖
export function publishRoomCart(data) {
  return post("/v1/roomCart/publish", data);
}

// 停止售卖
export function stopRoomCart(data) {
  return post("/v1/roomCart/stop", data);
}

// 广播消息
export function broadCastMsg(data) {
  return post("/v1/roomCart/broadcastMsg", data);
}
